<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 30/8/2020
  -->

<template>
	<div class="card p-1">
		<ToolTipView :analyticsProps="tooltipAnalyticsProps" >
			<template #icon><i
			   class="fontello icon-plus button-circle font-size-6"
			   @click="onButtonClicked('question')"/></template>
			Add question
		</ToolTipView>
<!--		<ToolTipView :analyticsProps="tooltipAnalyticsProps" >-->
<!--			<template #icon><i -->
<!--			   class="fontello icon-login button-circle font-size-6"-->
<!--			   @click="onButtonClicked('import')"/></template>-->
<!--			Import questions from another form-->
<!--		</ToolTipView>-->

		<ToolTipView :analyticsProps="tooltipAnalyticsProps" >
			<template #icon>
				<div
					class="button-circle font-size-6"
					style="font-weight: 600"
					@click="onButtonClicked('title')">T</div>
			</template>

			Add Title and Description
		</ToolTipView>

		<ToolTipView :analyticsProps="tooltipAnalyticsProps" >
			<template #icon><i
			   class="fontello icon-floppy button-circle font-size-6 color-primary"
			   @click="onButtonClicked('save')"/></template>
			Save changes
		</ToolTipView>

	</div>
</template>

<script>
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
export default {
	name: "FormMenu",
	components: {ToolTipView},
	props:{
		tooltipAnalyticsProps: Object
	},

	methods:{
		onButtonClicked(command){
			this.$emit("click", command)
		}
	}
}
</script>

<style>

</style>
